/* Pampas Mood — כמות, עיצוב וקובץ הדפסה פר יחידה */
(() => {
  if (window.pmAddonQtyReady) return;
  window.pmAddonQtyReady = true;

  const DEBUG = /pmqty_debug/.test(location.search);
  const q = (s, r = document) => r.querySelector(s);
  const qa = (s, r = document) => [...r.querySelectorAll(s)];
  const SPACES = new RegExp('[ \t\r\n]+', 'g');

  const injectCSS = () => {
    if (document.getElementById('pmAddonQtyStyles')) return;
    const st = document.createElement('style');
    st.id = 'pmAddonQtyStyles';
    st.textContent = [
      '.pampas-addons [hidden]{display:none!important}',
      '.pampas-addon__stepper>span{order:1}',
      '.pampas-addon__stepper [data-qty-plus]{order:2}',
      '.pampas-addon__stepper [data-qty-out]{order:3}',
      '.pampas-addon__stepper [data-qty-minus]{order:4}',
      '.pm-unit-head{display:flex;align-items:center;gap:8px;margin-bottom:4px}',
      '.pm-unit-head label{font-size:12px;color:var(--pm-color-text-muted);margin:0}',
      '.pm-unit-design-btn{margin-inline-start:auto;min-height:34px;padding:6px 14px;border:var(--pm-control-border-width) solid var(--pm-color-primary);border-radius:var(--pm-radius-pill);background:var(--pm-color-page);color:var(--pm-color-primary);font:inherit;font-size:12px;cursor:pointer}',
      '.pm-unit-design-btn[data-done="1"]{background:var(--pm-color-primary);color:var(--pm-color-on-primary)}'
    ].join('');
    document.head.appendChild(st);
  };
  injectCSS();

  const qtyInputFor = (row) => {
    let el = row;
    while (el && el !== document.documentElement) {
      const found = el.querySelector && el.querySelector('input[name="quantity"],select[name="quantity"]');
      if (found) return found;
      el = el.parentElement;
    }
    return q('input[name="quantity"],select[name="quantity"]');
  };

  const formFor = (row) => {
    let el = row;
    while (el && el !== document.documentElement) {
      const found = el.querySelector && el.querySelector('form[action*="/cart/add"]');
      if (found) return found;
      el = el.parentElement;
    }
    return q('form[action*="/cart/add"]');
  };

  const productQty = (row) => {
    const el = qtyInputFor(row);
    const v = parseInt((el && el.value) || '1', 10);
    const n = Math.max(1, isNaN(v) ? 1 : v);
    if (DEBUG) console.log('[pmqty] product qty =', n, 'from', el);
    return n;
  };

  const norm = (v) => String(v || '').normalize('NFC').replace(SPACES, ' ').trim();
  const money = (cents) => {
    const v = cents / 100;
    return (Number.isInteger(v) ? v : v.toFixed(2)) + ' ₪';
  };

  const rowQty = (row) => Math.max(1, parseInt(row.dataset.qty || '1', 10) || 1);
  const rowMode = (row) => (q('[data-design-mode]:checked', row) || {}).value || 'same';
  const isText = (row) => row.dataset.textMode === '1';
  const isDesignable = (row) => {
    const cb = q('input[data-addon-variant]', row);
    return isText(row) && !!(cb && cb.dataset.personalizationMode === 'sticker');
  };
  const priceCents = (row) => parseInt(row.dataset.priceCents || '0', 10) || 0;
  const isChecked = (row) => {
    const cb = q('input[data-addon-variant]', row);
    return !!(cb && cb.checked);
  };

  const rowTexts = (row) => {
    if (!isText(row)) return [];
    if (!isDesignable(row)) {
      const t = q('[data-addon-text-main]', row);
      return [String((t && t.value) || '').trim()];
    }
    if (rowQty(row) < 2 || rowMode(row) === 'same') {
      const t = q('[data-addon-text-main]', row);
      return [String((t && t.value) || '').trim()];
    }
    return qa('[data-unit-text]', row).slice(0, rowQty(row)).map((el) => String(el.value || '').trim());
  };

  const chargeUnits = (row) => {
    const qty = rowQty(row);
    if (!isText(row)) return qty;
    if (!isDesignable(row)) return qty;
    if (qty < 2 || rowMode(row) === 'same') return 1;
    const seen = new Set();
    rowTexts(row).forEach((t) => { const c = norm(t); if (c) seen.add(c); });
    return Math.max(1, seen.size);
  };

  const missingTexts = (row) => {
    if (isText(row) && !isDesignable(row)) {
      return norm(rowTexts(row)[0]) ? [] : [1];
    }
    if (!isText(row) || rowQty(row) < 2 || rowMode(row) === 'same') return [];
    return rowTexts(row).map((t, i) => (norm(t) ? 0 : i + 1)).filter(Boolean);
  };

  /* ---------- פתיחת מסך העיצוב עבור יחידה ספציפית ---------- */

  const openDesignerForUnit = (row, index, ta) => {
    const cb = q('input[data-addon-variant]', row);
    const mode = (cb && cb.dataset.personalizationMode) || 'sticker';
    window.pmActiveUnit = { row: row, index: index, ta: ta, label: 'יחידה ' + (index + 1) };
    if (DEBUG) console.log('[pmqty] open designer for unit', index + 1, mode);
    document.dispatchEvent(new CustomEvent('pampas:open-personalization', { detail: { mode: mode, target: ta } }));
  };

  /*
   * אחרי אישור עיצוב: הצינור המקורי יוצר קובץ PDF יחיד ומוחק את הקודם בכל אישור.
   * לכן אנחנו "חוטפים" את הקובץ שנוצר, נותנים לו שם ייחודי ליחידה ומסירים
   * ממנו את הסימון שהצינור מנקה — כך כל יחידה שומרת קובץ הדפסה משלה.
   */
  const captureUnitPrint = (form, u) => {
    if (!form || !u) return;
    const src = q('input[name="properties[טקסט הקדשה]"]', form);
    const text = String((src && src.value) || '').trim();
    if (text) {
      u.ta.value = text;
      u.ta.dispatchEvent(new Event('input', { bubbles: true }));
    }
    let captured = 0;
    qa('[data-pm-print]', form).forEach((el) => {
      el.removeAttribute('data-pm-print');
      el.dataset.pmUnitPrint = u.row.dataset.variant + '-' + u.index;
      if (el.name) el.name = el.name.replace(new RegExp('\\]$'), ' — ' + u.label + ']');
      captured++;
    });
    if (captured && !q('[data-pm-print][type="file"]', form)) {
      const dummy = document.createElement('input');
      dummy.type = 'file';
      dummy.hidden = true;
      dummy.dataset.pmPrint = '1';
      form.append(dummy);
    }
    if (!u.row._unitDone) u.row._unitDone = {};
    u.row._unitDone[u.index] = true;
    if (DEBUG) console.log('[pmqty] captured', captured, 'print nodes for', u.label);
    window.pmActiveUnit = null;
    refresh(u.row);
  };

  document.addEventListener('click', (e) => {
    if (!e.target.closest || !e.target.closest('#pmApprove')) return;
    const u = window.pmActiveUnit;
    if (!u) return;
    const form = formFor(u.row);
    setTimeout(() => {
      const done = () => captureUnitPrint(form, u);
      if (form && form._pmPrintPromise && typeof form._pmPrintPromise.then === 'function') {
        form._pmPrintPromise.then(done).catch(done);
      } else {
        done();
      }
    }, 150);
  }, true);

  /* ---------- רינדור שדות היחידות ---------- */

  const renderUnitFields = (row) => {
    const box = q('[data-unit-texts]', row);
    if (!box) return;
    if (!isChecked(row) || !isDesignable(row) || rowQty(row) < 2 || rowMode(row) === 'same') {
      box.hidden = true;
      return;
    }
    box.hidden = false;
    const qty = rowQty(row);
    const existing = qa('[data-unit-text]', box).map((el) => el.value);
    if (existing.length !== qty) {
      const main = String((q('[data-addon-text-main]', row) || {}).value || '').trim();
      box.replaceChildren();
      for (let i = 0; i < qty; i++) {
        const wrap = document.createElement('div');
        wrap.className = 'pm-unit-field';
        const head = document.createElement('div');
        head.className = 'pm-unit-head';
        const label = document.createElement('label');
        label.textContent = 'יחידה ' + (i + 1);
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pm-unit-design-btn';
        btn.dataset.unitDesign = String(i);
        btn.textContent = 'עיצוב היחידה';
        head.append(label, btn);
        const ta = document.createElement('textarea');
        ta.dataset.unitText = '1';
        ta.maxLength = parseInt(row.dataset.maxLen || '200', 10) || 200;
        ta.placeholder = 'הנוסח ליחידה ' + (i + 1);
        ta.value = existing[i] !== undefined ? existing[i] : (i === 0 ? main : '');
        wrap.append(head, ta);
        box.append(wrap);
      }
    }
    qa('[data-unit-design]', box).forEach((btn) => {
      const i = parseInt(btn.dataset.unitDesign, 10);
      const done = !!(row._unitDone && row._unitDone[i]);
      btn.dataset.done = done ? '1' : '0';
      btn.textContent = done ? '✓ עוצב — עריכה' : 'עיצוב היחידה';
    });
  };

  const refresh = (row) => {
    const max = productQty(row);
    const checked = isChecked(row);

    if (rowQty(row) > max) row.dataset.qty = String(max);
    const qty = rowQty(row);

    const stepper = q('[data-addon-stepper]', row);
    if (stepper) stepper.hidden = !checked || max < 2;

    const out = q('[data-qty-out]', row);
    if (out) out.textContent = String(qty);

    const minus = q('[data-qty-minus]', row);
    const plus = q('[data-qty-plus]', row);
    if (minus) minus.disabled = qty <= 1;
    if (plus) plus.disabled = qty >= max;

    const modes = q('[data-design-modes]', row);
    if (modes) modes.hidden = !checked || !isDesignable(row) || qty < 2;

    const main = q('[data-addon-text-main]', row);
    if (main) main.hidden = !checked || !isText(row) || (isDesignable(row) && qty >= 2 && rowMode(row) === 'different');

    renderUnitFields(row);

    const note = q('[data-addon-note]', row);
    if (!note) return;
    note.style.removeProperty('color');

    if (!checked) { note.textContent = ''; return; }

    if (!isText(row)) {
      note.textContent = qty > 1 ? qty + ' × ' + money(priceCents(row)) + ' = ' + money(qty * priceCents(row)) : '';
      return;
    }

    if (!isDesignable(row)) {
      note.textContent = qty > 1 ? qty + ' ברכות × ' + money(priceCents(row)) + ' = ' + money(qty * priceCents(row)) : '';
      return;
    }

    if (qty < 2) { note.textContent = ''; return; }

    if (rowMode(row) === 'same') {
      note.textContent = 'אותו נוסח לכל ' + qty + ' היחידות — ' + money(priceCents(row)) + ' בלבד';
      return;
    }

    const miss = missingTexts(row);
    if (miss.length) {
      note.textContent = 'חסר נוסח ליחידות: ' + miss.join(', ');
      note.style.color = '#9b2c2c';
      return;
    }
    const units = chargeUnits(row);
    note.textContent = units === 1
      ? 'כל הנוסחים זהים — ' + money(priceCents(row)) + ' בלבד'
      : units + ' עיצובים שונים — ' + money(units * priceCents(row));
  };

  const refreshAll = (scope) => qa('[data-addon-row]', scope || document).forEach(refresh);

  const initWrap = (wrap) => {
    if (!wrap || wrap.dataset.pmQtyInit) return;
    wrap.dataset.pmQtyInit = '1';

    wrap.addEventListener('click', (e) => {
      const design = e.target.closest('[data-unit-design]');
      if (design) {
        e.preventDefault();
        e.stopPropagation();
        const row = design.closest('[data-addon-row]');
        const i = parseInt(design.dataset.unitDesign, 10);
        const ta = qa('[data-unit-text]', row)[i];
        if (ta) openDesignerForUnit(row, i, ta);
        return;
      }
      const btn = e.target.closest('[data-qty-minus],[data-qty-plus]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      const row = btn.closest('[data-addon-row]');
      const max = productQty(row);
      const next = rowQty(row) + (btn.hasAttribute('data-qty-plus') ? 1 : -1);
      row.dataset.qty = String(Math.min(max, Math.max(1, next)));
      refresh(row);
    });

    wrap.addEventListener('change', (e) => {
      const row = e.target.closest('[data-addon-row]');
      if (!row) return;
      if (e.target.matches('input[data-addon-variant]') && !e.target.checked) {
        row.dataset.qty = '1';
        row._unitDone = {};
      }
      refresh(row);
    });

    wrap.addEventListener('input', (e) => {
      const row = e.target.closest('[data-addon-row]');
      if (row && e.target.matches('[data-unit-text],[data-addon-text-main]')) refresh(row);
    });

    const anyRow = q('[data-addon-row]', wrap);
    const qtyEl = anyRow && qtyInputFor(anyRow);
    if (qtyEl && !qtyEl.dataset.pmQtyWatched) {
      qtyEl.dataset.pmQtyWatched = '1';
      ['input', 'change', 'keyup'].forEach((evt) => qtyEl.addEventListener(evt, () => refreshAll(wrap)));
      let last = qtyEl.value;
      new MutationObserver(() => {
        if (qtyEl.value !== last) { last = qtyEl.value; refreshAll(wrap); }
      }).observe(qtyEl, { attributes: true, attributeFilter: ['value'] });
      if (qtyEl.parentElement) {
        qtyEl.parentElement.addEventListener('click', () => setTimeout(() => refreshAll(wrap), 60));
      }
    }

    refreshAll(wrap);
  };

  document.addEventListener('click', (e) => {
    if (e.target.closest && e.target.closest('[data-qty-minus],[data-qty-plus],[data-unit-design]')) return;
    setTimeout(() => refreshAll(document), 80);
  });

  qa('.pampas-addons').forEach(initWrap);

  new MutationObserver((ms) => ms.forEach((m) => m.addedNodes.forEach((n) => {
    if (n.nodeType !== 1) return;
    if (n.matches && n.matches('.pampas-addons')) initWrap(n);
    qa('.pampas-addons', n).forEach(initWrap);
  }))).observe(document.documentElement, { childList: true, subtree: true });

  window.pmAddonItems = (form, wrap, handle, parentVariant) => {
    const rows = qa('[data-addon-row]', wrap).filter(isChecked);
    if (!rows.length) return null;

    const problems = [];
    const items = rows.map((row) => {
      const qty = rowQty(row);
      const units = chargeUnits(row);
      const props = { _linked_to: handle, _parent_variant: parentVariant, 'כמות': String(qty) };

      if (isText(row)) {
        const miss = missingTexts(row);
        if (miss.length) {
          problems.push(isDesignable(row)
            ? row.dataset.label + ' — חסר נוסח ליחידות ' + miss.join(', ')
            : row.dataset.label + ' — חסר מלל לברכה');
        }
        props['סוג עיצוב'] = row.dataset.designLabel || '';
        if (qty >= 2 && rowMode(row) === 'different') {
          const notDesigned = [];
          for (let i = 0; i < qty; i++) {
            if (!(row._unitDone && row._unitDone[i])) notDesigned.push(i + 1);
          }
          if (notDesigned.length) problems.push(row.dataset.label + ' — יש לאשר עיצוב ליחידות ' + notDesigned.join(', '));
          props['אופן חלוקה'] = 'נוסח נפרד לכל יחידה';
          props['נוסחים'] = rowTexts(row).map((t, i) => (i + 1) + '. ' + norm(t)).join(' | ');
          props['קבצי הדפסה'] = qty + ' קבצי PDF נפרדים מצורפים להזמנה';
          if (units < qty) props['הערה'] = units + ' עיצובים שונים מתוך ' + qty + ' יחידות';
        } else {
          const t = rowTexts(row)[0] || '';
          if (t) props['טקסט'] = t;
          if (qty >= 2) props['אופן חלוקה'] = 'אותו נוסח לכל ' + qty + ' היחידות';
        }
      }

      return { id: parseInt(row.dataset.variant, 10), quantity: units, properties: props };
    });

    if (problems.length) throw new Error(problems.join(' | '));
    return items;
  };
})();

